export const environment = {
  production: false,
  uat: false,
  staging: true,
  development: false,
  environment: 'staging',
  baseUrl: 'https://stg-camiguin-api.tracwater.online', // Develop Server
  portalId: '6a6c16cf0fe4e5d2d84a2f5a',
  portalTypeId: '689596ee18f8a8985a2aebc5',
};
